/**
 * Command Palette — Cmd+K / Ctrl+K
 */
const COMMANDS = [
  { icon: 'bi-speedometer2', label: 'Project Dashboard', href: '/pages/dashboards/project-management.html', shortcut: 'G D' },
  { icon: 'bi-people', label: 'CRM Dashboard', href: '/pages/dashboards/crm.html' },
  { icon: 'bi-graph-up', label: 'Analytics', href: '/pages/dashboards/analytics.html' },
  { icon: 'bi-cart', label: 'E-commerce', href: '/pages/dashboards/ecommerce.html' },
  { icon: 'bi-envelope', label: 'Email Marketing', href: '/pages/dashboards/email-marketing.html' },
  { icon: 'bi-chat-dots', label: 'Messenger', href: '/pages/apps/messenger.html' },
  { icon: 'bi-folder', label: 'File Manager', href: '/pages/apps/file-manager.html' },
  { icon: 'bi-person', label: 'Contacts', href: '/pages/apps/contacts.html' },
  { icon: 'bi-check2-square', label: 'Todo', href: '/pages/apps/todo.html' },
  { icon: 'bi-calendar', label: 'Calendar', href: '/pages/apps/calendar.html' },
  { icon: 'bi-gear', label: 'Settings', href: '/pages/user/settings.html' },
  { icon: 'bi-moon', label: 'Toggle Dark Mode', action: 'toggle-theme' },
];

export const CommandPalette = {
  init() {
    this.el = document.getElementById('nw-command-palette');
    if (!this.el) return;

    this.input = this.el.querySelector('[data-nw-command-input]');
    this.list = this.el.querySelector('[data-nw-command-list]');
    this.selectedIndex = 0;

    this.render(COMMANDS);
    this.bindEvents();
  },

  open() {
    this.el?.classList.add('show');
    this.input?.focus();
    this.input.value = '';
    this.render(COMMANDS);
    this.selectedIndex = 0;
  },

  close() {
    this.el?.classList.remove('show');
  },

  render(items) {
    if (!this.list) return;
    this.list.innerHTML = items.map((cmd, i) => `
      <button class="nw-command-item ${i === this.selectedIndex ? 'active' : ''}" data-index="${i}" data-href="${cmd.href || ''}" data-action="${cmd.action || ''}">
        <i class="bi ${cmd.icon}"></i>
        <span>${cmd.label}</span>
        ${cmd.shortcut ? `<kbd class="nw-command-kbd">${cmd.shortcut}</kbd>` : ''}
      </button>
    `).join('');
  },

  filter(query) {
    const filtered = COMMANDS.filter((c) =>
      c.label.toLowerCase().includes(query.toLowerCase())
    );
    this.selectedIndex = 0;
    this.render(filtered);
    return filtered;
  },

  execute(cmd) {
    if (cmd.action === 'toggle-theme') {
      const current = localStorage.getItem('nw-theme') || 'auto';
      const next = current === 'dark' ? 'light' : 'dark';
      document.dispatchEvent(new CustomEvent('nw:toggle-theme', { detail: { theme: next } }));
      import('./theme.js').then(({ ThemeManager }) => ThemeManager.set(next));
    } else if (cmd.href) {
      window.location.href = cmd.href;
    }
    this.close();
  },

  bindEvents() {
    document.addEventListener('keydown', (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        this.el?.classList.contains('show') ? this.close() : this.open();
      }
      if (e.key === 'Escape') this.close();
    });

    this.input?.addEventListener('input', () => {
      this.filter(this.input.value);
    });

    this.input?.addEventListener('keydown', (e) => {
      const items = this.list?.querySelectorAll('.nw-command-item');
      if (!items?.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1);
        items.forEach((el, i) => el.classList.toggle('active', i === this.selectedIndex));
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
        items.forEach((el, i) => el.classList.toggle('active', i === this.selectedIndex));
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        const active = items[this.selectedIndex];
        if (active) {
          const href = active.dataset.href;
          const action = active.dataset.action;
          this.execute({ href, action });
        }
      }
    });

    this.list?.addEventListener('click', (e) => {
      const item = e.target.closest('.nw-command-item');
      if (item) {
        this.execute({ href: item.dataset.href, action: item.dataset.action });
      }
    });

    this.el?.addEventListener('click', (e) => {
      if (e.target === this.el) this.close();
    });
  },
};
